import React from 'react';
import { Translate } from 'react-redux-i18n';
import EventOrganizerInput from '../../eventOrganizers/input/EventOrganizerInput';

const CreateEventOrganizerContent = () => (
  <>
    <h2>
      <Translate value='eventOrganizers.page.create.title' />
    </h2>
    <EventOrganizerInput mode='create' />
  </>
);

export default CreateEventOrganizerContent;
